import { render, staticRenderFns } from "./WxpayTest.vue?vue&type=template&id=270eb39e&scoped=true"
import script from "./WxpayTest.vue?vue&type=script&lang=js"
export * from "./WxpayTest.vue?vue&type=script&lang=js"
import style0 from "./WxpayTest.vue?vue&type=style&index=0&id=270eb39e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270eb39e",
  null
  
)

export default component.exports